import React, { useState } from "react";
import { AppBar, Toolbar, Typography, Box, IconButton, Button, InputBase, Menu, MenuItem, Tooltip } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import MenuIcon from "@mui/icons-material/Menu";

import Avatar from "@mui/material/Avatar";
import { paths } from "../routes/path";
import { useNavigate } from "react-router-dom";

const Header = () => {
    const user = {
        name: "Admin",
        avatarUrl:  "https://i.pravatar.cc/40?img=3",
    };
    const [anchorEl, setAnchorEl] = useState(null);
    const openMenu = (event) => setAnchorEl(event.currentTarget);
    const closeMenu = () => setAnchorEl(null);
    const navigate = useNavigate();
    return (
        <AppBar position="fixed" sx={{ backgroundColor: "white", color: "black", boxShadow: 1 }}>
            <Toolbar sx={{ display: "flex", justifyContent: "space-between", px: { xs: 2, md: 10 } }}>
                <Box sx={{ display: "flex", alignItems: "center", ml: { md: 10, xs: 0 }, "&:hover": { cursor: 'pointer' } }} onClick={() => navigate(paths.PositionListPage)}>
                    <Avatar src="/logo.png" alt="Axcel" sx={{ marginRight: 2 }} />
                    <Typography variant="h6" fontWeight="bold">
                        Axcel
                    </Typography>
                    <Button sx={{ ml: 3, fontWeight: "bold", borderBottom: "3px solid #1976d2" }}>
                        Positions
                    </Button>
                </Box>
                <IconButton sx={{ display: { xs: "flex", md: "none" } }} onClick={openMenu}>
                    <MenuIcon />
                </IconButton>

                <Box sx={{ display: { xs: "none", md: "flex" }, alignItems: "center", gap: 2, mr: 10 }}>
                    <Box
                        sx={{
                            display: { xs: "none", md: "flex" },
                            alignItems: "center",
                            backgroundColor: "#f0f0f0",
                            borderRadius: 2,
                            px: 1,
                        }}
                    >
                        <SearchIcon />
                        <InputBase placeholder="Global search" sx={{ ml: 1 }} />
                    </Box>


                    <Box
                        sx={{
                            display: { xs: "none", md: "flex" },
                            alignItems: "center",
                            gap: 1,
                            cursor: 'pointer',
                            border: '1px solid lightgrey',
                            padding: '4px 10px',
                            borderRadius: '8px',
                            backgroundColor: 'white',
                            "&:hover": { backgroundColor: "#f5f5f5" }
                        }}
                        onClick={() => navigate(paths.settings)}
                    >
                        <Avatar
                            src={user.avatarUrl}
                            alt={user.name}
                            sx={{ width: 25, height: 25 }} 
                        />
                        <Typography variant="body2" color="text.secondary">{user.name}</Typography>
                    </Box>

                    <Tooltip title="Logout" arrow>
                        <IconButton>
                            <PowerSettingsNewIcon />
                        </IconButton>
                    </Tooltip>
                </Box>
                <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={closeMenu}>
                    <MenuItem onClick={() => navigate(paths.settings)}>
                        <Avatar src={user.avatarUrl} alt={user.name} sx={{ width: 30, height: 30, mr: 1 }} />
                        {user.name}
                    </MenuItem>
                    <MenuItem onClick={closeMenu}>
                        <PowerSettingsNewIcon sx={{ mr: 1 }} /> Logout
                    </MenuItem>

                </Menu>
            </Toolbar>
        </AppBar>
    );
};

export default Header;
